import { render, staticRenderFns } from "./EmbedCodeHighlight.vue?vue&type=template&id=79e358c2&scoped=true"
import script from "./EmbedCodeHighlight.vue?vue&type=script&lang=js"
export * from "./EmbedCodeHighlight.vue?vue&type=script&lang=js"
import style0 from "./EmbedCodeHighlight.vue?vue&type=style&index=0&id=79e358c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e358c2",
  null
  
)

export default component.exports